import { render, staticRenderFns } from "./PlantHarvests.vue?vue&type=template&id=1c56c429"
import script from "./PlantHarvests.vue?vue&type=script&lang=ts"
export * from "./PlantHarvests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports